import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';

export default class CrmBaseField extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            caller: props.Caller,
            data: null,
            loading: true,
            categories: []
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        var p1 = this.httpPost("api/v1/crm/basefields/get", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.state.data = data;
                }
            });

        var p2 = this.httpPost("api/v1/constantfororganization/list", { filters: { type: 1 } })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.state.categories = data.records;
                }
            });
        Promise.all([p1, p2]).then(r => {
            this.setState({
                loading: false
            })
        });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        if (this.isBlank(this.state.data.record.order)) this.state.data.record.order = 0;
        this.state.data.record.order = parseInt(this.state.data.record.order);

        this.httpPost("api/v1/crm/basefields/save", {
            id: this.state.id,
            title: this.state.data.record.title,
            dataType: this.state.data.record.dataType,
            order: this.state.data.record.order,
            categoriesId: this.state.data.record.categoriesId,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    getCategoryChecked(id) {
        var c = false;
        this.state.data.record.categoriesId.forEach(f => {
            if (f == id) c = true;
        });
        return c;
    }
    setCategoryChecked(id, checked) {
        var c = [];
        this.state.data.record.categoriesId.forEach(f => {
            if (f != id) c.push(f);
        });
        if (checked === true) c.push(id);
        this.state.data.record.categoriesId = c;
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "minWidth": "60%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات فیلد" : "افزودن فیلد جدید"}
                            </h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-12 mb-2">
                                        <div className="form-group">
                                            <label for="name" className="title1">عنوان</label><span className="red">*</span>
                                            <input defaultValue={this.state.data.record.title} onChange={e => this.state.data.record.title = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="title1">نوع فیلد</label><span className="red">*</span>
                                            <select defaultValue={this.state.data.record.dataType} onChange={e => this.state.data.record.dataType = parseInt(e.target.value)} className="form-control input-sm">
                                                <option value="1">متن</option>
                                                <option value="2">عدد</option>
                                                <option value="3">تاریخ</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-sm-3 mb-2">
                                        <div className="form-group">
                                            <label for="name" className="title1">اولویت</label><span className="red">*</span>
                                            <input defaultValue={this.state.data.record.order} onChange={e => this.state.data.record.order = parseInt(e.target.value)} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    {this.state.categories.map(cat =>
                                        <div className="col-sm-2">
                                            <div className="form-group">
                                                <input type="checkbox" onChange={e => this.setCategoryChecked(cat.id, e.target.checked)} defaultChecked={this.getCategoryChecked(cat.id)} /> {cat.name}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                            <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                ذخیره
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}